
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/[pageKey]",
      function () {
        return require("private-next-pages/site/[pageKey].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/[pageKey]"])
      });
    }
  